module.exports = __webpack_public_path__ + "static/img/result_main_banner.144e678f.png";